import { render } from "./PR30-06112023.vue?vue&type=template&id=dee585f8"
import script from "./PR30-06112023.vue?vue&type=script&lang=js"
export * from "./PR30-06112023.vue?vue&type=script&lang=js"

import exportComponent from "/Users/leviathan/sites/webbank/webbank-static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__